export const iconVariantPaths = {
  'attribute': 'attribute',
  'cus-him-info': 'him',
  'cus-him-l1': 'him',
  'cus-him-l2': 'him',
  'picto-l1': 'picto',
  'picto-l2': 'picto',
  'product-l1': 'product',
  'product-l2': 'product',
  'utilization': 'utilization',
  'wheelchair': 'wheelchair',
};
